<div data-ng-if="mainPartVisible">
    <button class="btn btn-sm btn-danger pull-right" style="margin-top:5px; margin-right:5px;" data-ng-click="ui.removeFrame(frame.id)"><i class="fa fa-trash-o fa-md"></i></button>
    <button class="btn btn-sm btn-danger pull-right" style="margin-top:5px; margin-right:5px;" data-ng-click="ui.editFrame()"><i class="fa fa-edit fa-md"></i></button>
    <p style="margin-left:3px; margin-top:3px;">{{frameHours}}</p>
    <p style="margin-left:3px">{{username}}</p>
</div>